import React, { useState, useEffect } from "react";
import { Table, Space, Button, message, Divider, Tabs } from "antd";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../../redux/ReconAndSettlement/actions";
import Uploads from "./Upload";
import Filter from "./Filter";
import moment from "moment";
import DateFilter from "../../../utils/DatePicker";

const columns = [
  { title: "Name", dataIndex: "name" },
  { title: "From Time", dataIndex: "fromTime" },
  { title: "To Time", dataIndex: "toTime" },
  { title: "Duration In Hrs.", dataIndex: "duration" },
];

const DevelopmentTable = () => {
  const dispatch = useDispatch();
  const { fetchReconGCPData, fetchReconData } = useSelector((state) => ({
    fetchReconGCPData: state.reconReducer?.fetchReconGCPData,
    fetchReconData: state.reconReducer?.fetchReconData,
  }));

  const { profileData } = useSelector((state) => {
    return {
      profileData: state.authReducer?.profileData,
    };
  });

  const { getGCPData } = actions;
  const [data, setData] = useState([]);
  const [selectedFile, setSelectedFile] = useState({ 
    11: 1, 
    fileType: "JSON", 
    date: new Date().toISOString(), 
  });
  const [dateRange, setDateRange] = useState({ fromDate: "", toDate: "" });
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const handleDateChange = (dates) => {
    if (dates) {
      setDateRange({ fromDate: dates[0], toDate: dates[1] });
    } else {
      setDateRange({ fromDate: "", toDate: "" });
    }
  };

  useEffect(() => {
    if (dateRange.fromDate && dateRange.toDate) {
      const payload = {
        startDate: moment(dateRange?.fromDate['$d'] || dateRange?.fromDate).format("YYYY-MM-DDTHH:mm:ss%2B05:30"),
        endDate: moment(dateRange?.toDate['$d'] || dateRange?.toDate).format("YYYY-MM-DDTHH:mm:ss%2B05:30"),
        page: currentPage,
        limit: pageSize,
      };
      dispatch(getGCPData(payload));
    }
  }, [dateRange, dispatch, getGCPData, currentPage, pageSize]);

  useEffect(() => {
    if (fetchReconGCPData?.data) {
      const fetchedData = Array.isArray(fetchReconGCPData.data) 
        ? fetchReconGCPData.data.map((item, index) => ({
            name: `Transaction-${index + 1}`,
            fromTime: moment(item?.startDate).format("YYYY-MM-DD HH:mm:ss") || "N/A",
            toTime: moment(item?.endDate).format("YYYY-MM-DD HH:mm:ss") || "N/A",
            duration: item?.fileName || "N/A",
            fileUrl: item?.url,
            key: index,
          }))
        : [];
      setData(fetchedData);
    }
  }, [fetchReconGCPData]);

  const handleTableChange = (pagination, filters, sorter) => {
    setCurrentPage(pagination.current);
    setPageSize(pagination.pageSize);
  };

  const items = [
    {
      key: "1",
      label: "Table",
      children: (
        <div>
          <h2 className="font-weight-bold mt-3">Request to Download</h2>
          <Filter 
            selectedFile={selectedFile} 
            setSelectedFile={setSelectedFile} 
            loading={fetchReconData?.loading} 
          />
          <Divider />
          <h2>Download Data</h2>
          <DateFilter onDateChange={handleDateChange} selectDateRange={setDateRange} />
          <Table
            columns={[
              ...columns,
              {
                title: "Actions",
                render: (_, record) => (
                  <Space>
                    <a 
                      href={record.fileUrl} 
                      style={{ cursor: "pointer" }} 
                      className="filter-button"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Download File
                    </a>
                  </Space>
                ),
              },
            ]}
            rowKey={(record) => record.key}
            dataSource={data}
            pagination={{
              total: fetchReconGCPData?.totalCount || data.length,
              current: currentPage,
              pageSize: pageSize,
              showSizeChanger: true,
              showQuickJumper: true,
              pageSizeOptions: ["5", "10", "20"],
            }}
            onChange={handleTableChange}
            loading={fetchReconGCPData?.loading}
          />
        </div>
      ),
    },
    {
      key: "2",
      label: "Upload",
      children: (
        <div className="dev-upload">
          <Uploads 
            selectedFile={selectedFile} 
            setSelectedFile={setSelectedFile} 
            loading={fetchReconData?.loading} 
          />
        </div>
      ),
    },
  ];

  return (
    <div>
      <Tabs
        style={{
          "--ant-tabs-tab-hover-color": "#2a901b",
          "--ant-tabs-tab-active-color": "#2a901b",
          "--ant-tabs-ink-bar-color": "#2a901b",
        }}
        defaultActiveKey="1"
        items={profileData?.internal !== false ? items : items.filter((item) => item.key !== "2")}
        onChange={(key) => key}
        indicator={{
          size: (origin) => origin - 20,
          align: "center",
        }}
        type="line"
        animated
      />
    </div>
  );
};

export default DevelopmentTable;